
import { mapState } from "vuex";

export default {
  props: {
    primary: { type: Object, required: true },
    mapId: { type: String, required: true },
  },

  computed: {
    ...mapState("app", ["isGoogleMapLoaded"]),
  },

  watch: {
    isGoogleMapLoaded: {
      handler(value) {
        value && this.storeMap();
      },
    },
  },

  mounted() {
    this.isGoogleMapLoaded && this.storeMap();
  },

  methods: {
    storeMap() {
      const { lat, lng, formatted_address: formattedAddress } = this.primary;
      // google map render
      const map = new window.google.maps.Map(
        document.getElementById(this.mapId),
        {
          zoom: 10,
          center: {
            lat,
            lng,
          },
        }
      );
      // eslint-disable-next-line no-unused-vars
      const marker = new window.google.maps.Marker({
        position: {
          lat,
          lng,
        },
        map,
        icon: "https://cdn.shopify.com/s/files/1/2657/7564/files/map-pin.png",
        title: formattedAddress,
      });
    },
  },
};
